import * as actions from "Actions";
import * as api from "Api";

export const fetchNotifs = ({ limit }) => (dispatch, getState) => {
  const { auth } = getState();
  const { token /*, user*/, navCommunity } = auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchNotifs(
      api.getNotifs({
        token,
        communityId: navCommunity.id,
        limit
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/notif.js